const $ = require('jquery')
$(document).ready(function () {
  if (typeof dataLayer !== 'undefined') {
    $('.datalayer--view-item').on('click', function () {
      const partId = $(this).data('part')
      const partName = $(this).data('part-name')
      const partPrice = $(this).data('part-price')
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: 'EUR',
          value: partPrice,
          items: [{
            item_id: partId,
            item_name: partName,
            price: partPrice
          }]
        }
      })

      $(document).ready(function () {
        const addToCartModal = $('.modal')
        const selectBoxPersonID = $('select[name="PersonID"]')
        addToCartModal.on('shown.bs.modal', function () {
          $('.datalayer--add-to-cart').on('click', function () {
            if (typeof selectBoxPersonID === 'undefined' || selectBoxPersonID.val() !== null) {
              window.dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                  currency: 'EUR',
                  value: partPrice,
                  items: [{
                    item_id: partId,
                    item_name: partName,
                    price: partPrice
                  }]
                }
              })
            }
          })
        })
      })
    })

    $('.datalayer--login-after-add-to-cart').on('click', function () {
      const partName = $(this).data('product-name')
      window.dataLayer.push({
        event: 'login_after_add_to_cart',
        partName
      })
    })

    $('.datalayer--begin-checkout').on('click', function () {
      const itemList = $(this).data('items')
      const currency = $(this).data('currency')
      const cartPrice = $(this).data('cart-price')
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency,
          value: cartPrice,
          items: itemList
        }
      })
    })

    $('.datalayer--back-to-cart').on('click', function () {
      window.dataLayer.push({
        event: 'back_to_cart'
      })
    })
  }
})
